/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import FileSaver from "file-saver";

import { AuthService } from "services/AuthService";
import { OrderService } from "../../../../../services/OrderService";
import { PublicService } from "../../../../../services/PublicService";
import { AccountService } from "services/AccountService";
import { PersonService } from "services/PersonService";
import { StockService } from "services/StockService";
import { MovementService } from "services/MovementServkce";
import { WSService } from "services/WSServices";

import { isMobile } from "helpers/Mobile";
import { capitalize } from "helpers/utils/utils_general";
import { stockByItem } from "helpers/stock/StockHelper";
import { EventRepository } from "helpers/EventRepository";
import { parseItems, itemsToSend } from "helpers/orders/ItemHelper";
import { Order, PrepOrder, RoadMapMovement } from "models/Orders";
import data from "./data";
import i18n from "i18n";

import usePagination from "hooks/usePagination";
import useAddItems from "hooks/useAddItems";
import useRequest from "hooks/useRequest";

import AdminLayout from "../../../../../components/MainApp/layouts/DesktopLayout";
import StepOne from "./steps/Step1";
import StepTwo from "./steps/Step2";
import StepThree from "./steps/Step3";
import StepTags from "./steps/StepTags/StepTags";
import LoadFinished from "../../../../../components/MainApp/organisms/Orders/RequestOrders/LoadOrderFinished";
import Wizard from "../../../../../components/MainApp/atoms/Wizard/StepProgress";
import RoundedButton from "../../../../../components/MainApp/atoms/RoundedButton";
import Loader from "../../../../../components/MainApp/atoms/Loader";

import styles from "./PrepOrders.LoadPrepOrder.module.scss";

export const LoadPrepOrderView = props => {
  const history = useHistory();
  const {
    loading,
    beforeSubmit,
    afterSubmit,
    errors,
    dealWithError
  } = useRequest();
  const [activestep, setactivestep] = useState("0");
  // Step 0
  const [order, setorder] = useState(null);
  const [reasons, setReasons] = useState(data.reasons);
  const [accounts, setAccounts] = useState([]);
  const [clients, setClients] = useState([]);
  const [fields, setFields] = useState([]);
  const [movement, setMovement] = useState(null);
  const [readTags, setreadTags] = useState([]);
  const [prevreadTags, setprevreadTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [movementItems, setMovementItems] = useState([]);
  const isSimplified = AuthService.getPermissions().includes(
    "skip_order_supervision"
  );

  const steps = isSimplified
    ? [
        { id: "0", name: capitalize(i18n.t("description")) },
        { id: "1", name: capitalize(i18n.t("tags")) },
        { id: "2", name: capitalize(i18n.t("confirmation")) }
      ]
    : [
        { id: "0", name: capitalize(i18n.t("description")) },
        { id: "1", name: capitalize(i18n.t("products")) },
        { id: "2", name: capitalize(i18n.t("confirmation")) }
      ];

  const [
    list,
    currentPage,
    pageSize,
    pageList,
    pageQuantity,
    changePageSize,
    changePage,
    changeList,
    restartPageList
  ] = usePagination([], 0, 3);

  const [
    productResultList,
    setproductResultList,
    selectedToAddProductList,
    setselectedToAddProductList,
    addedList,
    setaddedList,
    handleSelectToAddProduct,
    handleSelectedProductQuantityChange,
    handleAdd,
    handleAddProduct,
    handleDeleteAddedProduct,
    handleAddExtra,
    handleChangedLocations,
    handleDeleteAddedProductLocations
  ] = useAddItems(changeList, currentPage, pageSize);

  const [tagQuantitiesFromStep, setTagQuantitiesFromStep] = useState({}); // {itemId: quantity}
  const [tagStockIds, setTagStockIds] = useState({});
  const location = useLocation();
  const {
    preloadedTags = [],
    isFromAudit = false,
    auditId: auditIdFromState = null,
    auditDetailMap = {}
  } = location.state || {};

  useEffect(() => {
    setInitialOrder();
  }, []);

  const setInitialOrder = () => {
    const isAudit = preloadedTags.length > 0;

    if (!props.match.params.key) {
      setorder(new PrepOrder(data.initialOrder));
    } else {
      const id = props.match.params.key;
      beforeSubmit();
      OrderService.prepOrder(id)
        .then(order => {
          afterSubmit();
          setorder(order);
          // ONLY UPLOAD ITEMS IF IT IS NOT AN AUDIT FLOW
          if (!isAudit) {
            getItems(order.id, order.origin?.id);
          }
        })
        .catch(_ => {
          afterSubmit();
        });
    }

    const node_id = AuthService.getCurrentNodeCode();

    AccountService.accounts({ nodes: node_id, no_page: 1 }).then(response => {
      const accounts = response.map(a => {
        return { id: a.id, label: `${a.first_name} ${a.last_name}` };
      });
      setAccounts(accounts);
    });

    PersonService.persons({ type: "CLIENT", no_page: 1 }).then(response => {
      const clients = response.map(c => {
        return { id: c.id, label: `${c.name}` };
      });
      setClients(clients);
    });
  };

  useEffect(() => {
    if (!order) return;

    if (activestep === "0") {
      const newFields = order.loadStep1Fields(errors, accounts, clients);
      setFields(newFields);
    }
  }, [order, accounts, clients]);

  const filterProducts = value => {
    return getStockItems(value);
  };

  const getItems = (orderId, origin_node_id) => {
    // Audit flow: Skip fetching all items if a specific tag was preloaded from the audit.
    if (preloadedTags.length > 0) return;

    OrderService.getItems(orderId).then(response => {
      let addedListNew = parseItems(response);
      setaddedList(addedListNew);
      changeList(addedListNew, currentPage, pageSize);
      getStockItems(origin_node_id);
    });
  };

  const getStockItems = value => {
    // Audit flow: skipping stock check as preloadedTag is already verified.
    if (preloadedTags.length > 0) return Promise.resolve([]);

    const node_id = AuthService.getCurrentNodeCode();
    if (node_id !== null) {
      beforeSubmit();
      return new Promise((resolve, reject) => {
        StockService.stock({
          no_page: 1,
          status: "LOC",
          location__node: node_id,
          search: value
        })
          .then(res => {
            const _groupedStock = stockByItem(res);
            const _productResultList = _groupedStock.map(item => {
              return {
                id: item.id,
                sku: item.sku,
                name: item.title,
                stock: item.tags?.length ?? 0,
                units: 1
              };
            });
            setproductResultList(_productResultList);
            resolve(_productResultList);
            afterSubmit();
          })
          .catch(_ => {
            resolve([]);
            afterSubmit();
          });
      });
    }
  };

  const restart = () => {
    setorder(null);
    setaddedList([]);
    setreadTags([]);
    setprevreadTags([]);
    setMovement(null);
    setMovementItems([]);
    setactivestep("0");
    if (restartPageList) restartPageList();
    const newOrder = new PrepOrder({
      ...data.initialOrder,
      id: null
    });
    setorder(newOrder);
    setproductResultList([]);
  };

  const handleChange = e => {
    let name = e.target.name;
    let newOrder = order;
    newOrder[name] = e.target.value;
    const newFields = newOrder.loadStep1Fields(errors, accounts, clients);
    setFields(newFields);
    setorder(newOrder);
  };

  const handleSelect = (selectedOption, type) => {
    let orderAux = order;
    let newFields = {};
    switch (type) {
      case "reason":
        orderAux.klass = selectedOption.id;
        newFields = orderAux.loadStep1Fields(errors, accounts, clients);
        setFields(newFields);
        setorder(orderAux);
        break;
      case "owner":
        orderAux.owner = selectedOption;
        newFields = orderAux.loadStep1Fields(errors, accounts, clients);
        setFields(newFields);
        setorder(orderAux);
        break;
      case "client":
        orderAux.client = selectedOption;
        newFields = orderAux.loadStep1Fields(errors, accounts, clients);
        setFields(newFields);
        setorder(orderAux);
        break;
      default:
        break;
    }
  };

  const stepChangeHandler = step => {
    setactivestep(step);
  };

  const step0IsOk = () => {
    return (
      fields &&
      fields.findIndex(field => {
        return (
          field.data.required && (field.data.value === "" || !field.data.value)
        );
      }) === -1
    );
  };

  const nextStep = e => {
    e.preventDefault();

    if (isSimplified) {
      const func = {
        "0": e => stepOneSend(e),
        "1": e => stepTagsSend(e),
        "2": e => handleSubmit(e)
      };
      if (func[activestep]) func[activestep](e);
    } else {
      const func = {
        "0": e => stepOneSend(e),
        "1": e => stepTwoSend(e),
        "2": e => handleSubmit(e)
      };
      if (func[activestep]) func[activestep](e);
    }
  };

  const stepOneSend = e => {
    const data = order.dataToSend();
    beforeSubmit();
    const action = order.id
      ? OrderService.updateOrder(order.id, data)
      : OrderService.createOrder(data);

    action
      .then(response => {
        afterSubmit();
        setorder(new PrepOrder(response));
        stepChangeHandler("1");
      })
      .catch(error => {
        afterSubmit();
        dealWithError(error, "generic.error");
      });
  };

  const createRoadMap = async orderId => {
    if (!orderId) {
      EventRepository.notificationSend({
        label: i18n.t("required.order.id"),
        type: "error"
      });
      return null;
    }

    try {
      const data = order.dataCreateMovement();
      const response = await OrderService.addMovement(orderId, data);
      if (response.movement) {
        setMovement(response.movement);
      }
      return response;
    } catch (error) {
      dealWithError(error, "generic.error", (message, errors) => {
        const label =
          Object.keys(errors).length === 0
            ? message
            : i18n.t("cannot.start.movement");
        EventRepository.notificationSend({ label, type: "error" });
      });
      return null;
    }
  };

  const stepTwoSend = e => {
    const items = itemsToSend(addedList);

    beforeSubmit();
    OrderService.addItems(order.id, items)
      .then(response => {
        if (isSimplified) {
          OrderService.changeOrderStatus(order.id, "PRO", "Creation finished")
            .then(response => {
              createRoadMap(order.id);
            })
            .catch(error => {
              EventRepository.notificationSend({
                label: i18n.t("generic.error"),
                type: "error"
              });
            })
            .finally(() => {
              afterSubmit();
              stepChangeHandler("2");
            });
        } else {
          afterSubmit();
          stepChangeHandler("2");
        }
      })
      .catch(error => {
        afterSubmit();
      });
  };

  const executeSimplifiedOrderSetup = async () => {
    try {
      // Synchronize the items with the tags that were actually read
      const updatedItems = addedList.map(item => {
        const tagsForThisItem = readTags.filter(tag => tag.sku === item.sku);
        const totalQuantity = tagsForThisItem.length;
        return {
          ...item,
          units: totalQuantity || item.units || 1
        };
      });

      // Update the local state in case the user goes back.
      setaddedList(updatedItems);

      const itemsPayload = updatedItems.map(item => ({
        item_id: item.id,
        quantity: item.units,
        extra:
          item.extra && item.extra.length > 0
            ? item.extra.map(ex => ({
                item: item.id,
                item_id: item.id,
                location: ex.location,
                location_id: ex.location_id,
                location_label: ex.location_label,
                location__path_name: ex.location__path_name,
                unitsSelected: item.units,
                error: "",
                total: ex.total
              }))
            : []
      }));

      // POST items: The order must be in DRA (draft)
      await OrderService.addItems(order.id, itemsPayload);

      // POST status: Changed to PRO (processing)
      await OrderService.changeOrderStatus(
        order.id,
        "PRO",
        "Ready for dispatch"
      );

      // POST road-map: Created the movement (RoadMap)
      const moveData = order.dataCreateMovement();
      const roadMapResult = await OrderService.addMovement(order.id, moveData);

      // Created the model instance to have the correct structure.
      const newMovementInstance = new RoadMapMovement(roadMapResult);
      setMovement(newMovementInstance);

      // POST items to the movement: We use the stock IDs saved in the stepTags
      const itemsForMovement = readTags.map(tag => ({
        item_stock: tagStockIds[tag.rfid]
      }));

      const movementItemsResponse = await MovementService.addItems(
        newMovementInstance.movement.id,
        itemsForMovement
      );
      setMovementItems(movementItemsResponse);

      return newMovementInstance;
    } catch (error) {
      showError(i18n.t("generic.error"));
      return null;
    }
  };

  const stepTagsSend = e => {
    const numberTagsToRead = addedList.reduce((acc, item) => {
      return acc + (item.units ?? 1);
    }, 0);
    // if (readTags.length < numberTagsToRead) {
    //   EventRepository.notificationSend({
    //     label: i18n.t("all.tags.readings.are.yet.performed"),
    //     type: "error"
    //   });
    //   return;
    // }

    beforeSubmit();

    if (isSimplified) {
      // SIMPLIFIED FLOW
      afterSubmit();
      stepChangeHandler("2");
    } else {
      // STANDARD FLOW
      setTimeout(() => {
        afterSubmit();
        stepChangeHandler("2");
      }, 1000);
    }
  };

  const handleSubmit = async e => {
    if (e) e.preventDefault();
    beforeSubmit();

    if (!isSimplified) {
      // STANDARD FLOW
      OrderService.changeOrderStatus(order.id, "PRO", "Creation finished")
        .then(() => {
          afterSubmit();
          setactivestep("finish");
        })
        .catch(error => {
          afterSubmit();
          showError(i18n.t("change.status.error"));
        });
    } else {
      // SIMPLIFIED FLOW
      try {
        let currentMovement = movement;

        if (!currentMovement) {
          currentMovement = await executeSimplifiedOrderSetup();
        }

        if (!currentMovement) {
          afterSubmit();
          return;
        }

        const movementId = currentMovement.movement.id;

        // Change movement status to CLP
        await MovementService.changeStatus(movementId, "CLO", []);

        // Change movement status t VER_COM
        const tagList = readTags.map(tag => tag.rfid);
        await MovementService.changeStatus(movementId, "VER_COM", tagList);

        // --- AUDIT UPDATE ---
        if (isFromAudit && auditIdFromState) {
          await syncAuditDetails();
        }

        afterSubmit();
        setactivestep("finish");
      } catch (error) {
        afterSubmit();
        showError(i18n.t("change.status.error"));
      }
    }
  };

  const syncAuditDetails = async () => {
    try {
      // Obtain the IDs from the details that match the read RFIDs
      const detailIds = Object.entries(auditDetailMap)
        .filter(([rfid]) => readTags.some(tag => tag.rfid === rfid))
        .map(([rfid, detailId]) => detailId);

      if (detailIds.length === 0) return;

      await StockService.updateAuditHeader(auditIdFromState, { 
        detail_ids: detailIds 
      });

    } catch (error) {
      console.error("Error sincronizando auditoría:", error);
    }
  }

  const downloadVoucher = () => {
    beforeSubmit();
    OrderService.prepDownloadVoucher(order.id)
      .then(blob => {
        afterSubmit();
        FileSaver.saveAs(blob, "comprobante.pdf");
      })
      .catch(error => {
        afterSubmit();
      });
  };

  const goBackFunc = () => {
    history.push("/admin/orders/preparation");
  };

  const handleGoBackFromStep3 = () => {
    // Go back to StepTags first
    stepChangeHandler("0");

    // Then reset movement and movementItems
    setMovement(null);
    setMovementItems([]);
  };

  const validateTagOtherOrder = async tag => {
    if (!tag) return null;

    try {
      const filter = {
        status: "LOC",
        tag__rfid: tag,
        check_rfid_other_orders: order?.code || null
      };

      const response = await StockService.stock(filter);

      if (response.count > 0) {
        const itemData = response.results[0];

        if (!isSimplified) {
          // In STANDARD flow: Still require the product to be in addedList.
          const skuInAddedList = addedList.some(
            item => item.sku === itemData?.item?.sku
          );
          if (!skuInAddedList) {
            EventRepository.notificationSend({
              label: i18n.t("products.werenot.requested"),
              type: "error"
            });
            return null;
          }
        }
        // In SIMPLIFIED flow: Do not check addedList, allow the product to pass.

        return itemData;
      } else {
        EventRepository.notificationSend({
          label: i18n.t("tag.read.isnot.loaded.sistem", { cod: tag }),
          type: "error"
        });
        return null;
      }
    } catch (error) {
      afterSubmit();
      dealWithError(error, "generic.error", message => {
        EventRepository.notificationSend({
          label: message,
          type: "error"
        });
      });
      return null;
    }
  };

  const validateTagAndContinue = async value => {
    if (!value) return null;
    try {
      const validatedTag = await validateTagOtherOrder(value);
      return validatedTag;
    } catch (error) {
      return null;
    }
  };

  const handleSearch = async value => {
    if (!value) return;

    try {
      const validatedTag = await validateTagAndContinue(value);
      if (!validatedTag) return;

      if (readTags.some(tag => tag.rfid === value)) return; // No duplicates

      const epc = value.trim();
      const tagData = validatedTag.tag || {};
      const newTag = {
        rfid: tagData.rfid || epc,
        image: validatedTag.item?.image,
        tag: tagData.rfid || epc,
        barcode: tagData.barcode || null,
        sku: tagData.sku || validatedTag.item?.sku,
        variables: tagData.variables || {},
        batch: tagData.variables?.batch || null,
        expiration_date:
          tagData.variables?.expiration || validatedTag.expiration || null,
        location: validatedTag.location || null
      };

      // Save the ID of the validated tag stock
      setTagStockIds(prev => ({
        ...prev,
        [epc]: validatedTag.id
      }));

      // Only update UI
      setreadTags(prevTags => [...prevTags, newTag]);

      // Update addedList with the items read
      setaddedList(prev => {
        const existingItem = prev.find(i => i.id === validatedTag.item.id);
        if (existingItem) {
          return prev.map(i =>
            i.id === validatedTag.item.id
              ? {
                  ...i,
                  units: (i.units || 0) + 1,
                  extra: [
                    {
                      item: validatedTag.item.id,
                      item_id: validatedTag.item.id,
                      location: validatedTag.location.id,
                      location_id: validatedTag.location.id,
                      location_label: validatedTag.location.path_name,
                      location__path_name: validatedTag.location.path_name,
                      unitsSelected: (i.units || 0) + 1,
                      error: "",
                      total: validatedTag.location?.capacity || 0
                    }
                  ]
                }
              : i
          );
        } else {
          return [
            ...prev,
            {
              ...validatedTag.item,
              units: 1,
              location_label: validatedTag.location?.path_name,
              extra: [
                {
                  item: validatedTag.item.id,
                  item_id: validatedTag.item.id,
                  location: validatedTag.location.id,
                  location_id: validatedTag.location.id,
                  location_label: validatedTag.location.path_name,
                  location__path_name: validatedTag.location.path_name,
                  unitsSelected: 1,
                  error: "",
                  total: validatedTag.location?.capacity || 0
                }
              ]
            }
          ];
        }
      });
    } catch (error) {
      showError(i18n.t("generic.error"));
    }
  };

  const handleDelete = tag => {
    // Update addedList
    setaddedList(prev => {
      return prev
        .map(item => {
          if (item.sku === tag.sku) {
            const newUnits = (item.units || 1) - 1;
            return { ...item, units: newUnits };
          }
          return item;
        })
        .filter(item => item.units > 0);
    });

    // If it's a new order with no movement created, just remove it from the array.
    if (!movement || !movement.id) {
      setreadTags(prevTags => prevTags.filter(t => t.rfid !== tag.rfid));
      return;
    }

    const id = movementItems.find(
      item => item.item_stock?.tag?.rfid === tag.rfid
    )?.id;

    if (!id) {
      setreadTags(prevTags => prevTags.filter(t => t.rfid !== tag.rfid));
      return;
    }

    beforeSubmit();
    MovementService.deleteItems(movement.id, [{ id: id }])
      .then(response => {
        afterSubmit();
        setMovementItems(response);
        setreadTags(prevTags => prevTags.filter(t => t.rfid !== tag.rfid));
      })
      .catch(error => {
        afterSubmit();
        showError(i18n.t("generic.error"));
      });
  };

  // Manual Outbound Order for Audit Adjustment
  useEffect(() => {
    if (preloadedTags.length > 0 && order?.id && activestep === "0") {
      const processAuditFlow = async () => {
        beforeSubmit();
        try {
          const allNewTags = [];
          const allNewItems = [];
          const allStockIds = {};

          // Process all tags in parallel. We will validate each tag and build the new state arrays in one go.
          await Promise.all(
            preloadedTags.map(async rfid => {
              const validatedTag = await validateTagAndContinue(rfid);
              if (validatedTag) {
                const epc = rfid.trim();
                const targetSku =
                  validatedTag.tag?.sku || validatedTag.item?.sku;

                allNewTags.push({
                  rfid: epc,
                  tag: epc,
                  sku: targetSku,
                  image: validatedTag.item?.image,
                  variables: validatedTag.tag?.variables || {},
                  location: validatedTag.location
                });

                allStockIds[epc] = validatedTag.id;

                // Add to items list: Aggregate quantities for duplicate SKUs to prevent redundant UI entries.
                const existingItem = allNewItems.find(
                  i => i.id === validatedTag.item.id
                );
                if (existingItem) {
                  existingItem.units += 1;
                } else {
                  allNewItems.push({
                    ...validatedTag.item,
                    sku: targetSku,
                    units: 1,
                    location_label: validatedTag.location?.path_name,
                    extra: [
                      {
                        item_id: validatedTag.item.id,
                        location: validatedTag.location.id,
                        unitsSelected: 1,
                        location_label: validatedTag.location.path_name
                      }
                    ]
                  });
                }
              }
            })
          );

          // Batch state synchronization to prevent intermediate inconsistent states during tag processing.
          setTagStockIds(allStockIds);
          setreadTags(allNewTags);
          setaddedList(allNewItems);

          if (changeList) {
            changeList(allNewItems, 0, 3);
          }

          // Refresh order data if type is not 'AUD'.
          if (order.klass !== "AUD") {
            const fresh = await OrderService.prepOrder(order.id);
            setorder(fresh);
          }

          // Bypass intermediate steps and proceed directly to Confirmation.
          setTimeout(() => {
            setactivestep("2");
            afterSubmit();
          }, 500);
        } catch (e) {
          afterSubmit();
        }
      };
      processAuditFlow();
    }
  }, [order?.id, preloadedTags.length]);

  const handleDeleteAll = () => {
    // If no movement created yet, just clear the local state
    if (!movement || !movement.id || movementItems.length === 0) {
      setreadTags([]);
      setprevreadTags([]);
      setMovementItems([]);
      setaddedList([]);
      return;
    }

    // If movement exists, delete items from server
    beforeSubmit();
    const ids = movementItems.map(m => {
      return { id: m.id };
    });

    MovementService.deleteItems(movement.id, ids)
      .then(response => {
        setMovementItems([]);
        setreadTags([]);
        setprevreadTags([]);
        setaddedList([]);
      })
      .catch(error => showError(i18n.t("generic.error")))
      .finally(() => {
        afterSubmit();
      });
  };

  const receiveEvent = async payload => {
    const ws = WSService.getInstance();
    if (payload.method === "EVENT" && payload.room && ws.inRoom(payload.room)) {
      const newreads = payload.data.map(tag => ({ rfid: tag }));
      setprevreadTags(prev => [...prev, ...newreads]);
    }
  };

  // function that maps rfid to itemId and quantity
  const handleTagQuantityChange = (rfid, quantity) => {
    setTagQuantitiesFromStep(prev => ({
      ...prev,
      [rfid]: quantity
    }));
  };

  const showError = message => {
    EventRepository.notificationSend({
      label: message,
      type: "error"
    });
  };

  const content = (
    <div className={styles["load-request-order-content"]}>
      {activestep !== "finish" ? (
        <div className={styles["load-request-order-wrapper"]}>
          <div className={styles["load-request-order-wizard"]}>
            <Wizard
              steps={steps}
              activeStep={activestep}
              clickEnabled={false}
            ></Wizard>
          </div>

          <div className={styles["load-request-order-step"]}>
            {activestep === "0" && (
              <form onSubmit={nextStep} className={styles["content"]}>
                <StepOne
                  order={order}
                  options={reasons}
                  handleChange={handleChange}
                  handleSelect={handleSelect}
                  fields={fields}
                />
                <div className={styles["load-request-order-button"]}>
                  <div>
                    <RoundedButton
                      legend={i18n.t("continue").toUpperCase()}
                      type="submit"
                      state={step0IsOk() ? "enabled" : "disabled"}
                      handleClick={nextStep}
                    ></RoundedButton>
                  </div>
                </div>
              </form>
            )}

            {activestep === "1" && (
              <div className={styles["content"]}>
                {isSimplified ? (
                  /* IF SIMPLIFIED, STEP 1 IS THE TAGS */
                  <StepTags
                    readTags={readTags}
                    handleSearch={handleSearch}
                    handleDelete={handleDelete}
                    handleDeleteAll={handleDeleteAll}
                    handleSend={nextStep}
                    isSimplified={true}
                    enabledRead={true}
                    typeRead={"READ"}
                    receiveEvent={receiveEvent}
                    onTagQuantityChange={handleTagQuantityChange}
                    goBackFunc={handleGoBackFromStep3}
                  />
                ) : (
                  <StepTwo
                    handleChange={handleChange}
                    resultList={productResultList}
                    searchValue={""}
                    products={isMobile ? addedList : pageList}
                    totalProducts={addedList.length}
                    handleSelectToAddProduct={handleSelectToAddProduct}
                    handleChangedLocations={handleChangedLocations}
                    handleAdd={selectedFromModal => {
                      if (
                        selectedFromModal &&
                        !Array.isArray(selectedFromModal)
                      ) {
                        // If we receive a single object, we put it into an array
                        handleAddExtra([selectedFromModal]);
                      } else {
                        // If nothing is specified, handleAddExtra will use selectedToAddProductList by default.
                        handleAddExtra();
                      }
                    }}
                    handleAddProduct={handleAddProduct}
                    selectedProducts={selectedToAddProductList.map(p => p.id)}
                    handleDeleteAddedProduct={handleDeleteAddedProductLocations}
                    changePage={changePage}
                    pagination={{
                      pageQuantity: pageQuantity,
                      currentPage: currentPage
                    }}
                    filter={filterProducts}
                  />
                )}
                {!isSimplified && (
                  <div className={styles["load-request-order-button"]}>
                    <div>
                      <RoundedButton
                        legend={i18n.t("continue").toUpperCase()}
                        type="submit"
                        state={addedList.length > 0 ? "enabled" : "disabled"}
                        handleClick={e => nextStep(e)}
                      ></RoundedButton>
                    </div>
                  </div>
                )}
              </div>
            )}

            {activestep === "2" && (
              <StepThree
                products={addedList}
                readTags={readTags}
                handleEditDest={() => stepChangeHandler("0")}
                handleEditProducts={() => stepChangeHandler("1")}
                order={order}
                handleSubmit={handleSubmit}
                goBackFunc={() => stepChangeHandler(isSimplified ? "1" : "1")}
                isSimplified={isSimplified}
              />
            )}
          </div>
        </div>
      ) : (
        <div className={styles["load-request-order-wrapper-finish"]}>
          <div
            className={styles["load-request-order-wrapper-finish-container"]}
          >
            <LoadFinished
              orderNumber={order.code}
              boldButtonFunc={restart}
              downloadVoucher={downloadVoucher}
              buttonLink={"/admin/orders/preparation"}
            />
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div className={styles["load-request-order-container"]}>
      <AdminLayout
        headerTitle={i18n.t("new.departure.order")}
        headerOptions={data.headerOptions}
        content={content}
        goBackFunc={activestep !== "finish" ? goBackFunc : null}
        navHidden={true}
      ></AdminLayout>

      {loading && <Loader />}

      {/* <SingleLoadExitModal
          open={this.state.goBackConfirm}
          confirm={() => this.props.history.push("/admin/products/load")}
          cancel={() => this.setState({ goBackConfirm: false })}
          handleClose={() => this.setState({ goBackConfirm: false })}
        /> */}
    </div>
  );
};

export default LoadPrepOrderView;
